import { createRoot } from 'react'
import { renderFields } from "./components";
import ReloadUsersCourses from './components/admin/ReloadUsersCourses';

renderFields()

window.addEventListener('load', () => {

    if ( document.getElementsByClassName('wp-heading-inline').length !== 0 ) {
        if ( document.getElementsByClassName('wp-heading-inline')[0].outerText === 'Edit Membership Plan' ) {
            document.getElementsByClassName('wp-heading-inline')[0].outerHTML += '<span id="msync-reload-members-courses"></span>'

            let element = document.getElementById('msync-reload-members-courses')
            console.log(element)

            createRoot(element).render(
                <React.StrictMode>
                    <ReloadUsersCourses />
                </React.StrictMode>
            )

        }
    }
})
